// src/modules/branches/constants/branchConstants.js

export const BRANCH_TYPE = {
  HO: 'HO',
  BRANCH: 'BRANCH',
};

export const BRANCH_TYPE_OPTIONS = [
  { label: 'Head Office (HO)', value: BRANCH_TYPE.HO },
  { label: 'Branch', value: BRANCH_TYPE.BRANCH },
];

export const BRANCH_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  UNDER_MAINTENANCE: 'under_maintenance',
  CLOSED: 'closed'
};

export const BRANCH_STATUS_OPTIONS = [
  { label: 'Active', value: BRANCH_STATUS.ACTIVE, color: 'green' },
  { label: 'Inactive', value: BRANCH_STATUS.INACTIVE, color: 'orange' },
  { label: 'Under Maintenance', value: BRANCH_STATUS.UNDER_MAINTENANCE, color: 'blue' },
  { label: 'Closed', value: BRANCH_STATUS.CLOSED, color: 'red' }
];

export const WORKING_DAYS = [
  'Monday',
  'Tuesday', 
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

export const DEFAULT_WORKING_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday', 
  'Thursday',
  'Friday',
  'Saturday'
];

export const BRANCH_FORM_VALIDATION = {
  NAME: {
    required: true,
    min: 2,
    max: 100
  },
  CODE: {
    required: true,
    pattern: /^[A-Z0-9]{3,10}$/,
    message: 'Code should be 3-10 characters long and contain only uppercase letters and numbers'
  },
  CITY: {
    required: true,
    min: 2,
    max: 50
  },
  STATE: {
    required: true,
    min: 2,
    max: 50
  },
  PHONE: {
    pattern: /^[+]?[\d\s\-\(\)]{10,15}$/,
    message: 'Please enter a valid phone number (10-15 digits)'
  },
  EMAIL: {
    type: 'email',
    message: 'Please enter a valid email address'
  },
  POSTAL_CODE: {
    pattern: /^[A-Za-z0-9\s\-]{3,10}$/,
    message: 'Please enter a valid postal code'
  }
};

export const BRANCH_TABLE_COLUMNS = {
  MOBILE: ['name', 'status', 'actions'],
  TABLET: ['name', 'code', 'status', 'location', 'actions'],
  DESKTOP: ['name', 'code', 'location', 'manager', 'status', 'contact', 'actions']
};

export const BRANCH_PERMISSIONS = {
  VIEW: 'branches:view',
  CREATE: 'branches:create',
  EDIT: 'branches:edit',
  DELETE: 'branches:delete',
  MANAGE: 'branches:manage'
};

export const API_ENDPOINTS = {
  BRANCHES: '/branches',
  BRANCH_BY_ID: (id) => `/branches/${id}`,
  BRANCH_STATS: '/branches/stats',
  USERS: '/users'
};

export const PAGINATION_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: ['10', '20', '50', '100'],
  SHOW_SIZE_CHANGER: true,
  SHOW_QUICK_JUMPER: true
};

export const RESPONSIVE_CONFIG = {
  MOBILE_BREAKPOINT: 'xs',
  TABLET_BREAKPOINT: 'sm', 
  DESKTOP_BREAKPOINT: 'md',
  LARGE_DESKTOP_BREAKPOINT: 'lg'
};
